import React, { useMemo } from "react"

import { PriceProps } from "../../../../../../../../interfaces/PriceProps"
import { getProperServicePrice } from "../../../../../../../../helpers/getPropersServicePrice"
import { useGetUniquePrices } from "../../../../../../../../helpers/useGetUniqiePrice"

import style from "./style.module.scss"

import { CURRENCY } from "utils/constants"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import { formatPrice } from "utils/utils"
import { useDiscountViewData } from "modules/discount"
import { useSearchParams } from "utils/customHooks"
import { SurveyResultsStorage } from "modules/NewClientSurvey/common/utils/SurveyResultsStorage"

export function PriceTemplate({ psy }: PriceProps) {
    const [{ isVerified }] = useClientContext()
    const searchParams = useSearchParams()
    const subject = searchParams.get("subject") ?? SurveyResultsStorage.subject

    const servicePrice = getProperServicePrice(psy.offered_services, subject)

    const {
        hasDiscount,
        price: [oldPrice, newPrice],
    } = useDiscountViewData(psy, servicePrice)

    const { uniquePrices } = useGetUniquePrices(psy)
    const price = useMemo(
        () => {
            if (isVerified) return servicePrice
            return hasDiscount ? newPrice : oldPrice
        },
        isVerified ? [servicePrice, undefined, undefined] : [hasDiscount, newPrice, oldPrice]
    )

    if (price !== undefined)
        return (
            <span>
                {uniquePrices.length > 1 && <>От&nbsp;</>}
                <span className={style.price}>{formatPrice(price, CURRENCY.RUB)}</span>
            </span>
        )
    return <></>
}
